import { render, staticRenderFns } from "./couponUseCount.vue?vue&type=template&id=198b2c48&scoped=true&"
import script from "./couponUseCount.vue?vue&type=script&lang=js&"
export * from "./couponUseCount.vue?vue&type=script&lang=js&"
import style0 from "./couponUseCount.vue?vue&type=style&index=0&id=198b2c48&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198b2c48",
  null
  
)

export default component.exports